import seoServicesData from "../../data/SeoServices.json";

export default function SectionSeoServices() {
    return (
        <div className="w-full SectionSeoServices">
            <div className="w-full section-container">
                {/* Section Heading */}
                <div className="w-[90%] md:w-[61%] text-center m-[24px_20px] md:mx-auto">
                    <h2 className="text-[24px] md:text-[34px] font-bold leading-[32px] md:leading-[41px] text-[#151515] my-[0.67em]">
                        Our <span className="text-[#DA2128]">SEO Services</span>
                    </h2>

                    <p className="text-gray-600 text-sm md:text-base mb-10 leading-[26px]">
                        We provide full stack search engine optimization services designed to improve rankings,
                        traffic quality, and conversions.
                    </p>
                </div>

                {/* Cards Grid */}
                <div className="boxes p-[2%_0%_3%_0%] flex justify-center flex-wrap w-[85%] mx-auto gap-x-[2%] gap-y-[19px] md:gap-y-[30px]">
                    {seoServicesData.map((service, index) => (
                        <div
                            key={index}
                            className={`${(index + 1) % 2 === 0
                                    ? "bg-[#f5f5f5] text-[#373737]"
                                    : "bg-[#E42E35] text-white"
                                } p-[10%] xs:p-[3%] xl:w-[30%] w-[90%] xs:w-[46%] rounded-lg shadow-lg`}
                        >
                            <h3 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] my-[0.67em] capitalize">
                                {service.title}
                            </h3>
                            <p
                            className="space-y-2 text-xs md:text-sm leading-[20px] font-open mb-3"
                            dangerouslySetInnerHTML={{ __html: service.description }}
                            />

                            {/* Bullet Points */}
                            <ul className="list-disc space-y-2 text-xs md:text-sm leading-[20px] font-open pl-5">
                            {service.text.map((point, i) => (
                                <li
                                key={i}
                                dangerouslySetInnerHTML={{ __html: point }}
                                />
                            ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>

            {/* Optional Divider */}
            <div className="line mb-[55px] mt-[1%] md:mt-[5%] md:mb-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
        </div>
    );
}
